import React, {useState, useRef, useEffect, ReactNode} from 'react';
import {LucideAArrowDown, LucideBlocks, LucideIcon} from "lucide-react";

interface DropdownMenuProps {
    trigger: ReactNode; 
    children: ReactNode; 
    position?: 'left' | 'right' | 'center'; 
    onItemClick?: () => void;
}

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
}

interface DropdownMenuItemModalProps {
    title: string;
    ModalComponent: React.ComponentType<ModalProps>;
}

interface DropdownMenuProps {
    trigger: React.ReactNode;
    children: React.ReactNode;
    position?: 'left' | 'center' | 'right';
    onItemClick?: () => void;
}

export const DropdownMenu: React.FC<DropdownMenuProps> = ({
                                                              trigger,
                                                              children,
                                                              position = 'right',
                                                              onItemClick,
                                                          }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isSticky) return;

        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsOpen(false);
                setIsSticky(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isSticky]);

    const handleMouseEnter = () => setIsOpen(true);

    const handleMouseLeave = () => {
        if (!isSticky) setIsOpen(false);
    };

    const handleTriggerClick = () => {
        const newState = !isSticky;
        setIsSticky(newState);
        setIsOpen(newState);
    };

    const handleMenuClick = () => {
        setIsOpen(false);
        setIsSticky(false);
        onItemClick?.();
    };

    const positionClass = {
        left: 'left-0',
        center: 'left-1/2 -translate-x-1/2',
        right: 'right-0',
    }[position] || 'left-0';

    return (
        <div
            ref={menuRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className="relative inline-block"
        >
            <div onClick={handleTriggerClick}>{trigger}</div>
            {isOpen && (
                <div
                    onClick={handleMenuClick}
                    className={`absolute top-full z-50 ${positionClass}`}
                >
                    {children}
                </div>
            )}
        </div>
    );
};

export const DropdownMenuItems = ({onOpenAccountModal}) => {
    return (
        <div
            id="user-menu"
            className="mt-4 w-48 bg-surface-900 border border-surface-500 rounded-lg shadow-xl z-20"
        >
            <DropdownMenuItem title="Login to Account" onClick={onOpenAccountModal}/>
            <DropdownMenuItemPage url="account" title="Account" icon={LucideBlocks} isRed={false} />
            <DropdownMenuItemPage url="logout" title="Log Out" icon={LucideBlocks} isRed={true}/>
            
        </div>
    );
};

interface DropDownProps  {
    url: string;
    title: string;
    icon: LucideIcon;
    isRed: boolean;
}

const DropdownMenuItemPage = (props :DropDownProps) => {
    const Icon = props.icon;
    return (
        <div className="flex flex-row">
            {/*<Icon className="w-4 h-4" />*/}
            <DropdownMenuItem
                title={props.title}
                isRed={props.isRed}
                href={props.url}
            />
        </div>
    );
};


const DropdownMenuItem = ({title, isRed = false, ...rest}) => {
    return (
        <a
            className={`flex px-4 py-2 text-sm 
            hover:bg-surface-900 transition-all rounded-b-lg  ${isRed ? 'text-red-400' : 'text-surface-300'} 
            `}
            {...rest}
        >
            {title}
        </a>
    );
};




















